import React from "react";
import Breadcrumb from "../../../components/layout/Breadcrumb/breadcrumbProfile";
import UserLayout from "../../../components/layout/UserLayout";

import TapContainer from "./TapContainer";
import UserInfo from "./UserInfo";

export default function Profile() {
  return (
    <main className="px-[50px] md:px-[100px] bg-[#F5F9FF]">
      <Breadcrumb />
  
      <div className="container-fluid">
        <UserLayout >
        <article className="w-full flex flex-col gap-[20px]">
            <UserInfo />
            <TapContainer />
          </article>
        </UserLayout>
        </div>
    </main>
  );
}
